module.exports = __webpack_public_path__ + "img/PA.c8526ff0.svg";